import React from 'react';
import './Footer.css';
import Logo from '../assets/logo.png';

function Footer() {
    return (
        <footer className="footer">
            <img src={Logo} alt="Desafío Extremo - Skydiving Uruguay" className="footer__logo" />
            <p>© {new Date().getFullYear()} Escuela de Paracaidismo Desafío Extremo</p>
            <p>Síguenos en Instagram:</p>
            <div className="footer__social">
                <a href="https://www.instagram.com/paracaidismouy/" target="_blank" rel="noopener noreferrer">@paracaidismo.uy</a>
                <a href="https://www.instagram.com/desafioextremo.uruguay/" target="_blank" rel="noopener noreferrer">@desafioextremo.uruguay</a>
            </div>
        </footer>
    );
}

export default Footer;
